<template>
    <div class="container">
        <b-row>
            <b-container>
                <h3 class="text-center py-2" v-if="!generado">
                    <b><i>{{ tituloConsolidado }}</i></b>
                </h3>

                <h5 class="text-center py-2">
                    <b-row class="mb-4 justify-content-center align-items-end text-lg">
                        <b-col md="auto" class="text-center px-3">
                            <label class="d-block fw-bold fs-4 mb-3"><b>Cod. Reporte:</b></label>
                            <select v-model="dialogReportes" @click="isEmpty = true"
                                class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
                                <option value="">Seleccione...</option>
                                <option v-for="reporte in reportes" :key="reporte.id" :value="reporte.codigo">
                                    {{ reporte.nombre }}
                                </option>
                            </select>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <label class="d-block fw-bold fs-4 mb-3"><b>Vigencia:</b></label>
                            <select v-model="dialogFechas" @click="isEmpty = true"
                                class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
                                <option value="">Seleccione...</option>
                                <option v-for="fecha in fechas" :key="fecha.fecha" :value="fecha.fecha">
                                    {{ fecha.fecha }}
                                </option>
                            </select>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <label class="d-block fw-bold fs-4 mb-3"><b>Grupo:</b></label>
                            <select v-model="grupoId" @change="filtraCompaniasPorGrupo()"
                                class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
                                <option value="todos">Todos los grupos</option>
                                <option v-for="grupo in listGrupos" :key="'grupo-' + grupo.id" :value="grupo.id">
                                    {{ grupo.nombre }}
                                </option>
                            </select>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <label class="d-block fw-bold fs-4 mb-3"><b>Compañía:</b></label>
                            <select v-model="dialogCompanias" @click="seleccionaCompania()"
                                class="form-control form-control-lg w-auto mx-auto fs-5"
                                style="min-width: 180px; max-width: 250px;">
                                <option value="">Seleccione...</option>
                                <option v-for="compania in companiasFiltradas" :key="compania.id" :value="compania.id">
                                    {{ compania.acronym ? compania.acronym + ' ' : '' }}{{ compania.nombre }}
                                </option>
                            </select>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4 justify-content-center align-items-center">
                        <b-col md="auto" class="text-center px-3">
                            <input type="checkbox" id="Balance" value="Balance" @click="uncheck(1)" class="mr-1">
                            <label for="Balance" class="fw-bold">Balance</label>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <input type="checkbox" id="Comparativo" value="Comparativo" @click="uncheck(3)" class="mr-1">
                            <label for="Comparativo" class="fw-bold">Comparativo</label>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <input type="checkbox" id="Consolidado" value="Consolidado" @click="uncheck(2)" class="mr-1">
                            <label for="Consolidado" class="fw-bold">Consolidado</label>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <input type="checkbox" id="Reporte" value="Reporte" @click="uncheck(4)" class="mr-1">
                            <label for="Reporte" class="fw-bold">Reporte</label>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <input type="checkbox" id="ReporteConsol" value="ReporteConsol" @click="uncheck(6)" class="mr-1">
                            <label for="ReporteConsol" class="fw-bold">Reporte Consol</label>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <input type="checkbox" id="Notas" value="Notas" @click="uncheck(7)" class="mr-1">
                            <label for="Notas" class="fw-bold">Notas</label>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <input type="checkbox" id="Informacion" value="Informacion" @click="uncheck(5)" class="mr-1">
                            <label for="Informacion" class="fw-bold">Información</label>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4 justify-content-center align-items-center">
                        <b-col md="auto" class="text-center" v-if="Consolidado">
                            <input type="checkbox" id="Empresas" value="Empresas" @click="uncheck(21)" class="mr-1">
                            <label for="Empresas" class="fw-bold">Empresas</label>
                        </b-col>

                        <b-col md="auto" class="text-center" v-if="ReporteConsol">
                            <input type="checkbox" id="EmpresasReporte" value="EmpresasReporte" @click="uncheck(61)" class="mr-1">
                            <label for="EmpresasReporte" class="fw-bold">Empresas</label>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4 justify-content-center align-items-center">
                        <b-col md="auto" class="text-center">
                            <b-button variant="primary" @click="generar" class="btn-lg px-5 mx-2 fs-5">
                                <b><i>{{ labels.generar }}</i></b>
                            </b-button>
                        </b-col>
                    </b-row>

                    <b-row v-if="empresasSeleccion && (Consolidado || ReporteConsol)" class="mt-4">
                        <b-col md="12">
                            <div class="consolidation-section p-4 border rounded bg-light">
                                <label class="d-block fw-bold fs-5 mb-3 text-center">
                                    <b>Empresas para consolidar:</b>
                                </label>

                                <div class="mb-3 text-center">
                                    <b-form-checkbox v-model="selectAllCompanies" @change="toggleAllCompanies"
                                        class="fw-bold fs-6">
                                        {{ selectAllCompanies ? 'Deseleccionar todas' : 'Seleccionar todas' }}
                                    </b-form-checkbox>
                                </div>

                                <div class="companies-checkbox-list"
                                    style="max-height: 300px; overflow-y: auto; border: 1px solid #ccc; padding: 15px; border-radius: 5px; background-color: white;">
                                    <b-form-checkbox-group v-model="EmpresasConsolida" stacked class="checkbox-group">
                                        <b-form-checkbox v-for="compania in companiasFiltradas" :key="compania.id"
                                            :value="compania.id" class="company-checkbox">
                                            {{ compania.acronym }} {{ compania.nombre }}
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>

                                <div class="text-center mt-3">
                                    <b-button variant="outline-secondary" @click="empresasSeleccion = false" class="btn-sm">
                                        Ocultar selección
                                    </b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </h5>
            </b-container>
        </b-row>

        <b-row v-if="isLoading">
            <b-container class="text-center py-5">
                <b-col md="12">
                    <div class="loading-spinner mb-3">
                        <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
                    </div>
                    <h4 class="text-primary">
                        <b><i>Cargando información...</i></b>
                    </h4>
                </b-col>
            </b-container>
        </b-row>

        <b-row>
            <b-container v-if="!isLoading && !isEmpty && Balance" class="pb-5">
                <md-table v-model="balanceFiltrado" md-card md-fixed-header
                    :class="{ 'balance-table': true, 'principal-table': true }">
                    <md-table-toolbar>
                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <div style="flex: 1; text-align: center;">
                                <h1 class="md-title"><b><i>{{ tituloConsolidado }}</i></b></h1>
                            </div>
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <md-button v-if="fgl_excel" @click="excel(1)" class="md-fab md-primary"
                                    style="margin-left: 10px;">
                                    <md-icon>description</md-icon>
                                </md-button>
                            </div>
                        </div>
                    </md-table-toolbar>
                    <md-table-row slot="md-table-row" slot-scope="{ item }" v-if="!ocultarRegistro(item)">
                        <md-table-cell :md-label="labels.descripcion" class="text-left border descripcion-cell">{{
                            item.descripcion }}</md-table-cell>
                        <md-table-cell :md-label="labels.saldo_actual" class="text-right border number-cell"
                            v-if="f_escribe_renglon(item.informacion)">{{ formato(item.saldo_actual) }}</md-table-cell>
                        <md-table-cell :md-label="labels.saldo_actual" class="text-right border"
                            v-if="!f_escribe_renglon(item.informacion)"></md-table-cell>
                        <md-table-cell :md-label="labels.funcional1" class="text-right border number-cell"
                            v-if="f_escribe_renglon(item.informacion)">{{ formato(item.funcional1) }}</md-table-cell>
                        <md-table-cell :md-label="labels.funcional1" class="text-right border"
                            v-if="!f_escribe_renglon(item.informacion)"></md-table-cell>
                        <md-table-cell :md-label="labels.promedio1" class="text-right border number-cell"
                            v-if="f_escribe_renglon(item.informacion)">{{ formato(item.promedio1) }}</md-table-cell>
                        <md-table-cell :md-label="labels.promedio1" class="text-right border"
                            v-if="!f_escribe_renglon(item.informacion)"></md-table-cell>
                        <md-table-cell :md-label="labels.funcional2" class="text-right border number-cell"
                            v-if="f_escribe_renglon(item.informacion)">{{ formato(item.funcional2) }}</md-table-cell>
                        <md-table-cell :md-label="labels.funcional2" class="text-right border"
                            v-if="!f_escribe_renglon(item.informacion)"></md-table-cell>
                        <md-table-cell :md-label="labels.promedio2" class="text-right border number-cell"
                            v-if="f_escribe_renglon(item.informacion)">{{ formato(item.promedio2) }}</md-table-cell>
                        <md-table-cell :md-label="labels.promedio2" class="text-right border"
                            v-if="!f_escribe_renglon(item.informacion)"></md-table-cell>
                    </md-table-row>
                </md-table>
            </b-container>

            <b-container v-if="!isLoading && !isEmpty && Consolidado" class="pb-5">
                <md-table v-model="balanceFiltrado" md-card md-fixed-header
                    :class="{ 'balance-table': true, 'principal-table': true }">
                    <md-table-toolbar>
                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <div style="flex: 1; text-align: center;">
                                <h1 class="md-title"><b><i>{{ tituloConsolidado }}</i></b></h1>
                            </div>
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <md-button v-if="fgl_excel" @click="excel(3)" class="md-fab md-primary"
                                    style="margin-left: 10px;">
                                    <md-icon>description</md-icon>
                                </md-button>
                            </div>
                        </div>
                    </md-table-toolbar>
                    <md-table-row slot="md-table-row" slot-scope="{ item }" v-if="!ocultarRegistro(item)">
                        <md-table-cell :md-label="labels.descripcion" class="text-left border descripcion-cell">{{
                            item.descripcion }}</md-table-cell>
                        <md-table-cell :md-label="titulo_columna[0]" class="text-right border number-cell"
                            v-if="columnas >= 1 && f_escribe_renglon(item.informacion)">{{ formato(item.c1)
                            }}</md-table-cell>
                        <md-table-cell :md-label="titulo_columna[0]" class="text-right border"
                            v-if="columnas >= 1 && !f_escribe_renglon(item.informacion)"></md-table-cell>
                        <md-table-cell :md-label="titulo_columna[1]" class="text-right border number-cell"
                            v-if="columnas >= 2 && f_escribe_renglon(item.informacion)">{{ formato(item.c2)
                            }}</md-table-cell>
                        <md-table-cell :md-label="titulo_columna[1]" class="text-right border"
                            v-if="columnas >= 2 && !f_escribe_renglon(item.informacion)"></md-table-cell>
                        <md-table-cell :md-label="titulo_columna[2]" class="text-right border number-cell"
                            v-if="columnas >= 3 && f_escribe_renglon(item.informacion)">{{ formato(item.c3)
                            }}</md-table-cell>
                        <md-table-cell :md-label="titulo_columna[2]" class="text-right border"
                            v-if="columnas >= 3 && !f_escribe_renglon(item.informacion)"></md-table-cell>
                        <md-table-cell :md-label="titulo_columna[3]" class="text-right border number-cell"
                            v-if="columnas >= 4 && f_escribe_renglon(item.informacion)">{{ formato(item.c4)
                            }}</md-table-cell>
                        <md-table-cell :md-label="titulo_columna[3]" class="text-right border"
                            v-if="columnas >= 4 && !f_escribe_renglon(item.informacion)"></md-table-cell>
                        <md-table-cell :md-label="titulo_columna[4]" class="text-right border number-cell"
                            v-if="columnas >= 5 && f_escribe_renglon(item.informacion)">{{ formato(item.c5)
                            }}</md-table-cell>
                        <md-table-cell :md-label="titulo_columna[4]" class="text-right border"
                            v-if="columnas >= 5 && !f_escribe_renglon(item.informacion)"></md-table-cell>
                        <md-table-cell :md-label="labels.ajustes" class="text-right border number-cell"
                            v-if="columnas > 0 && f_escribe_renglon(item.informacion)">{{ formato(item.ajustes)
                            }}</md-table-cell>
                        <md-table-cell :md-label="labels.ajustes" class="text-right border"
                            v-if="columnas > 0 && !f_escribe_renglon(item.informacion)"></md-table-cell>
                        <md-table-cell :md-label="labels.consolidado" class="text-right border number-cell"
                            v-if="columnas > 0 && f_escribe_renglon(item.informacion)">{{ formato(item.total)
                            }}</md-table-cell>
                        <md-table-cell :md-label="labels.consolidado" class="text-right border"
                            v-if="columnas > 0 && !f_escribe_renglon(item.informacion)"></md-table-cell>
                    </md-table-row>
                </md-table>
            </b-container>

            <b-container v-if="!isLoading && !isEmpty && Comparativo" class="pb-5">
                <md-table v-model="balanceFiltrado" md-card md-fixed-header
                    :class="{ 'balance-table': true, 'principal-table': true }">
                    <md-table-toolbar>
                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <div style="flex: 1; text-align: center;">
                                <h1 class="md-title"><b><i>{{ tituloConsolidado }}</i></b></h1>
                            </div>
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <md-button v-if="fgl_excel" @click="excel(2)" class="md-fab md-primary"
                                    style="margin-left: 10px;">
                                    <md-icon>description</md-icon>
                                </md-button>
                            </div>
                        </div>
                    </md-table-toolbar>
                    <md-table-row slot="md-table-row" slot-scope="{ item }" v-if="!ocultarRegistro(item)">
                        <md-table-cell :md-label="labels.descripcion" class="text-left border descripcion-cell">{{
                            item.descripcion }}</md-table-cell>
                        <md-table-cell :md-label="titulo(0)" class="text-right border number-cell"
                            v-if="f_escribe_renglon(item.informacion)">{{ formato(item.anterior) }}</md-table-cell>
                        <md-table-cell :md-label="titulo(0)" class="text-right border"
                            v-if="!f_escribe_renglon(item.informacion)"></md-table-cell>
                        <md-table-cell :md-label="titulo(1)" class="text-right border number-cell"
                            v-if="f_escribe_renglon(item.informacion)">{{ formato(item.actual) }}</md-table-cell>
                        <md-table-cell :md-label="titulo(1)" class="text-right border"
                            v-if="!f_escribe_renglon(item.informacion)"></md-table-cell>
                        <md-table-cell :md-label="labels.diferencia" class="text-right border number-cell"
                            v-if="f_escribe_renglon(item.informacion)">{{ formato(item.diferencia) }}</md-table-cell>
                        <md-table-cell :md-label="labels.diferencia" class="text-right border"
                            v-if="!f_escribe_renglon(item.informacion)"></md-table-cell>
                        <md-table-cell :md-label="titulo(2)" class="text-right border number-cell"
                            v-if="f_escribe_renglon(item.informacion)">{{ formato(item.funcional_ant) }}</md-table-cell>
                        <md-table-cell :md-label="titulo(2)" class="text-right border"
                            v-if="!f_escribe_renglon(item.informacion)"></md-table-cell>
                        <md-table-cell :md-label="titulo(3)" class="text-right border number-cell"
                            v-if="f_escribe_renglon(item.informacion)">{{ formato(item.funcional_act) }}</md-table-cell>
                        <md-table-cell :md-label="titulo(3)" class="text-right border"
                            v-if="!f_escribe_renglon(item.informacion)"></md-table-cell>
                        <md-table-cell :md-label="labels.funcional_dif" class="text-right border number-cell"
                            v-if="f_escribe_renglon(item.informacion)">{{ formato(item.funcional_dif) }}</md-table-cell>
                        <md-table-cell :md-label="labels.funcional_dif" class="text-right border"
                            v-if="!f_escribe_renglon(item.informacion)"></md-table-cell>
                    </md-table-row>
                </md-table>
            </b-container>

            <b-container v-if="!isLoading && !isEmpty && (Reporte || ReporteConsol)" class="pb-5">
                <md-table v-model="balanceFiltrado" md-card md-fixed-header
                    :class="{ 'balance-table': true, 'principal-table': true }">
                    <md-table-toolbar>
                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <div style="flex: 1; text-align: center;">
                                <h1 class="md-title"><b><i>{{ tituloConsolidado }}</i></b></h1>
                            </div>
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <md-button v-if="fgl_excel" @click="excel(5)" class="md-fab md-primary"
                                    style="margin-left: 10px;">
                                    <md-icon>description</md-icon>
                                </md-button>
                                <md-button v-if="ReporteConsol" @click="cambiaAjuste" class="md-fab md-accent"
                                    style="margin-left: 10px;">
                                    <md-icon>swap_horiz</md-icon>
                                </md-button>
                            </div>
                        </div>
                    </md-table-toolbar>
                    <md-table-row slot="md-table-row" slot-scope="{ item }" v-if="!ocultarRegistro(item)">
                        <md-table-cell :md-label="labels.filacolumna" class="text-left border descripcion-cell">{{
                            f_fila(item.fila) }}</md-table-cell>
                        <md-table-cell :md-label="titulo_columna_ecp[0]" class="text-right border number-cell"
                            v-if="maxcolumnas >= 1">{{ formato(item.val1) }}</md-table-cell>
                        <md-table-cell :md-label="titulo_columna_ecp[1]" class="text-right border number-cell"
                            v-if="maxcolumnas >= 2">{{ formato(item.val2) }}</md-table-cell>
                        <md-table-cell :md-label="titulo_columna_ecp[2]" class="text-right border number-cell"
                            v-if="maxcolumnas >= 3">{{ formato(item.val3) }}</md-table-cell>
                        <md-table-cell :md-label="titulo_columna_ecp[3]" class="text-right border number-cell"
                            v-if="maxcolumnas >= 4">{{ formato(item.val4) }}</md-table-cell>
                        <md-table-cell :md-label="titulo_columna_ecp[4]" class="text-right border number-cell"
                            v-if="maxcolumnas >= 5">{{ formato(item.val5) }}</md-table-cell>
                    </md-table-row>
                </md-table>
            </b-container>

            <b-container v-if="!isLoading && !isEmpty && Informacion" class="pb-5">
                <md-table v-model="balanceFiltrado" md-card md-fixed-header @md-selected="f_muestra"
                    :class="{ 'balance-table': true, 'detalle-table': true }">
                    <md-table-toolbar>
                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <div style="flex: 1; text-align: center;">
                                <h1 class="md-title"><b><i>{{ tituloConsolidado }}</i></b></h1>
                            </div>
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <md-button v-if="fgl_excel" @click="excel(4)" class="md-fab md-primary"
                                    style="margin-left: 10px;">
                                    <md-icon>description</md-icon>
                                </md-button>
                            </div>
                        </div>
                    </md-table-toolbar>
                    <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single"
                        v-if="!ocultarRegistro(item)">
                        <md-table-cell :md-label="labels.fila" class="text-left border descripcion-cell">{{
                            item.fila_desc }}</md-table-cell>
                        <md-table-cell :md-label="labels.columna" class="text-left border descripcion-cell">{{
                            item.columna_desc }}</md-table-cell>
                        <md-table-cell :md-label="labels.monto" class="text-right border number-cell">{{
                            formato(item.valor) }}</md-table-cell>
                    </md-table-row>
                </md-table>
            </b-container>

            <b-container v-if="!isLoading && !isEmpty && Notas" class="pb-5">
                <md-table v-model="notasEFFiltrado" md-card md-fixed-header @md-selected="f_muestra_nota"
                    :class="{ 'balance-table': true, 'detalle-table': true }">
                    <md-table-toolbar>
                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <div style="flex: 1; text-align: center;">
                                <h1 class="md-title"><b><i>{{ tituloConsolidado }}</i></b></h1>
                            </div>
                        </div>
                    </md-table-toolbar>
                    <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single"
                        v-if="!ocultarRegistroNota(item)">
                        <md-table-cell :md-label="labels.nota" class="text-left border descripcion-cell">{{
                            item.numero }}</md-table-cell>
                        <md-table-cell :md-label="labels.descripcion" class="text-left border descripcion-cell">{{
                            item.descripcion }}</md-table-cell>
                    </md-table-row>
                </md-table>
            </b-container>

            <b-container v-if="!isLoading && isEmpty">
                <b-col md="2" class="mx-auto">
                    <div class="success-svg mb-4" :class="{ active: isEmpty }">
                        <img src="../../assets/imgs/file-2.svg" alt="warning" />
                    </div>
                </b-col>
                <b-col md="12" class="justify-content-around">
                    <span id="message" v-if="isEmpty">{{ labels.empty }}</span>
                </b-col>
            </b-container>
        </b-row>

        <md-dialog :md-active.sync="showDialog">
            <md-dialog-title class="text-center">
                <h3><b><i>{{ f1_titulo() }}</i></b></h3>
            </md-dialog-title>
            <md-dialog-content>
                <md-table v-model="cuentas" md-card md-fixed-header>
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell :md-label="labels.cuenta" class="text-left border">{{ item.cuenta }}</md-table-cell>
                        <md-table-cell :md-label="labels.descripcion_cuenta" class="text-left border">{{ item.descripcion }}</md-table-cell>
                        <md-table-cell :md-label="labels.saldo_actual" class="text-right border">{{ formato(item.saldo_actual) }}</md-table-cell>
                        <md-table-cell :md-label="labels.funcional1" class="text-right border">{{ formato(item.funcional1) }}</md-table-cell>
                        <md-table-cell :md-label="labels.promedio1" class="text-right border">{{ formato(item.promedio1) }}</md-table-cell>
                        <md-table-cell :md-label="labels.funcional2" class="text-right border">{{ formato(item.funcional2) }}</md-table-cell>
                        <md-table-cell :md-label="labels.promedio2" class="text-right border">{{ formato(item.promedio2) }}</md-table-cell>
                    </md-table-row>
                </md-table>
                <md-dialog-actions>
                    <md-button class="md-accent" @click="showDialog = false">Cerrar</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>

        <md-dialog :md-active.sync="showDialogInformacion">
            <md-dialog-title class="text-center">
                <h3><b><i>{{ labels.informacion }}</i></b></h3>
            </md-dialog-title>
            <md-dialog-content>
                <b-form-group @submit.prevent="editaInfoBalance">
                    <b-row><b-col>
                            <h6>{{ labels.fila }}</h6>
                        </b-col>
                        <b-col cols=7> <md-field> <md-input v-model="formInformacion.fila_desc" type="text"
                                    readonly></md-input></md-field></b-col></b-row>
                    <b-row><b-col>
                            <h6>{{ labels.columna }}</h6>
                        </b-col>
                        <b-col cols=7> <md-field> <md-input v-model="formInformacion.columna_desc" type="text"
                                    readonly></md-input></md-field></b-col></b-row>
                    <b-row><b-col>
                            <h6>{{ labels.monto }}</h6>
                        </b-col>
                        <b-col cols=7> <md-field> <md-input v-model="formInformacion.valor"
                                    type="text"></md-input></md-field></b-col></b-row>
                </b-form-group>
                <md-dialog-actions>
                    <md-button class="md-primary" @click="f_grabaInformacion()">Guardar</md-button>
                    <md-button class="md-accent" @click="showDialogInformacion = false">Cerrar</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
import Balance from "@/services/BalanceNiif"
import Grupo from "@/services/Grupo"
import * as XLSX from "exceljs"

export default {
    name: "ReporteECP",

    data: () => ({
        rolSeleccionado: {},
        myOptions: [],
        rolSelected: '',
        formCuentas: {},
        showDialog: false,
        showDialogInformacion: false,
        dialogItem: {},
        balance: [],
        ajustes: [],
        cuentas: [],
        notasEF: [],
        searched: [],
        isEmpty: true,
        isLoading: false,
        fgl_excel: true,
        error: false,
        formInformacion: {
            fila: '',
            fila_desc: '',
            columna: '',
            columna_desc: '',
            valor: '',
            u_modifica: '',
        },
        idCompania: 0,
        vigencia: '',
        codReporte: '',
        Balance: false,
        Comparativo: false,
        Consolidado: false,
        Empresas: false,
        EmpresasReporte: false,
        Reporte: false,
        ReporteConsol: false,
        Notas: false,
        Informacion: false,
        companias: [],
        companiasFiltradas: [],
        companiaUsuario: [],
        dialogCompanias: '',
        EmpresasConsolida: [],
        fechas: [],
        dialogReportes: '',
        reportes: [],
        dialogFechas: '',
        columnas: 0,
        titulo_columna: [],
        titulo_columna_ecp: [],
        empresa: 0,
        generado: false,
        codigoCompanias: "",
        moneda: '',
        ecpfilas: [],
        ecpcolumnas: [],
        maxcolumnas: 0,
        rutaExcel: '',
        path: '',
        consol: true,
        tituloConsolidado: "",
        listGrupos: [],
        grupoId: 'todos',
        selectAllCompanies: false,
        empresasSeleccion: false,
    }),
    computed: {
        balanceFiltrado() {
            if (!this.balance || this.balance.length === 0) return [];
            return this.balance.filter((item, index) => !this.ocultarRegistro(item, index, this.balance));
        },
        notasEFFiltrado() {
            if (!this.notasEF || this.notasEF.length === 0) return [];
            return this.notasEF.filter((item, index) => !this.ocultarRegistroNota(item, index, this.notasEF));
        },
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "CAMBIO EN EL PATRIMONIO",
                    codigo: "Codigo",
                    descripcion: "Descripcion",
                    saldo_actual: "Saldo",
                    funcional1: "Funcional",
                    promedio1: "Promedio",
                    funcional2: "Alterna",
                    promedio2: "Promedio",
                    diferencia: "Diferencia",
                    funcional_dif: "Dif Funcional",
                    compania: "Compañía",
                    empty: "Sin Información",
                    notFoundMessage: "Sin Información",
                    generar: "Generar",
                    ajustes: "Ajustes",
                    consolidado: "Consolidado",
                    moneda: "Moneda",
                    fila: "Fila",
                    columna: "Columna",
                    monto: "Valor",
                    filacolumna: "Fila / Columna",
                    nota: "Nota",
                    cuenta: "Cuenta",
                    descripcion_cuenta: "Descripción",
                    informacion: "Información Manual",
                }
            } else {
                return {
                    title: "CHANGE IN EQUITY",
                    codigo: "Code",
                    descripcion: "Description",
                    saldo_actual: "Balance",
                    funcional1: "Functional",
                    promedio1: "Average",
                    funcional2: "Alternative",
                    promedio2: "Average",
                    diferencia: "Difference",
                    funcional_dif: "Dif Functional",
                    compania: "Company",
                    empty: "Without Information",
                    notFoundMessage: "Without Information",
                    generar: "Generate",
                    ajustes: "Settings",
                    consolidado: "Consolidated",
                    moneda: "Currency",
                    fila: "Row",
                    columna: "Column",
                    monto: "Amount",
                    filacolumna: "Row / Column",
                    nota: "Note",
                    cuenta: "Account",
                    descripcion_cuenta: "Description",
                    informacion: "Manual Information",
                }
            }
        }
    },
    methods: {
        filtraCompaniasPorGrupo() {
            this.isEmpty = true
            this.dialogCompanias = null

            if (this.grupoId === 'todos' || !this.grupoId) {
                this.companiasFiltradas = [...this.companias]
            } else {
                const grupoIdStr = this.grupoId.toString()
                this.companiasFiltradas = this.companias.filter(compania => {
                    if (!compania.id_grupos) return false
                    const gruposCompania = compania.id_grupos.split(',').map(id => id.trim())
                    return gruposCompania.includes(grupoIdStr)
                })
            }
        },

        toggleAllCompanies() {
            if (this.selectAllCompanies) {
                this.EmpresasConsolida = this.companiasFiltradas.map(c => c.id)
            } else {
                this.EmpresasConsolida = []
            }
        },

        ocultarRegistro(item, index, array) {
            if (!item) return false;

            if (item.informacion === "I" && item.saldo_actual !== null && parseFloat(item.saldo_actual) === 0) {
                return true;
            }

            if (item.informacion === "T" && item.saldo_actual !== null && parseFloat(item.saldo_actual) === 0) {
                return true;
            }

            if (item.informacion === "E" && index > 0) {
                for (let i = index - 1; i >= 0; i--) {
                    const anterior = array[i];
                    if (!anterior) continue;
                    if (anterior.informacion === "E" &&
                        anterior.descripcion === item.descripcion) {
                        if (anterior.segundo_nivel === 0 && item.segundo_nivel > 0) {
                            return true;
                        }
                        if (anterior.segundo_nivel < item.segundo_nivel) {
                            break;
                        }
                    }
                }
            }

            return false;
        },

        ocultarRegistroNota(item) {
            if (!item) return false;
            return false;
        },

        seleccionaCompania() {
            this.isEmpty = true;
            let buscaMoneda = this.companias.filter((item) => item.id == this.dialogCompanias);
            if (buscaMoneda.length > 0) {
                this.moneda = buscaMoneda[0].acronimo;
            }
        },

        f_titulo() {
            let titulo = ""
            let tituloEN = ""
            switch (this.$route.name) {
                case "reporteEcp":
                    titulo = "CAMBIO EN EL PATRIMONIO-ECP"
                    tituloEN = "CHANGE IN EQUITY-ECP"
                    break;
            }
            this.tituloConsolidado = ""
            if (this.$store.state._language == "es-ES") {
                this.tituloConsolidado = titulo
            } else {
                this.tituloConsolidado = tituloEN
            }
            if (this.Consolidado) {
                if (this.$store.state._language == "es-ES") {
                    this.tituloConsolidado = titulo.concat(" CONSOLIDADO")
                } else {
                    this.tituloConsolidado = "CONSOLIDATED"
                    this.tituloConsolidado = this.tituloConsolidado.concat(" ", tituloEN)
                }
            }
            if (this.Comparativo) {
                if (this.$store.state._language == "es-ES") {
                    this.tituloConsolidado = titulo.concat(" COMPARATIVO")
                } else {
                    this.tituloConsolidado = "COMPARATIVE"
                    this.tituloConsolidado = this.tituloConsolidado.concat(" ", tituloEN)
                }
            }
            if (this.Reporte) {
                if (this.$store.state._language == "es-ES") {
                    this.tituloConsolidado = titulo.concat(" REPORTE")
                } else {
                    this.tituloConsolidado = "REPORT"
                    this.tituloConsolidado = this.tituloConsolidado.concat(" ", tituloEN)
                }
            }
            if (this.Informacion) {
                if (this.$store.state._language == "es-ES") {
                    this.tituloConsolidado = titulo.concat(" INFORMACION")
                } else {
                    this.tituloConsolidado = "INFORMATION"
                    this.tituloConsolidado = this.tituloConsolidado.concat(" ", tituloEN)
                }
            }
            if (this.ReporteConsol && this.consol) {
                if (this.$store.state._language == "es-ES") {
                    this.tituloConsolidado = titulo.concat(" REPORTE CONSOLIDADO")
                } else {
                    this.tituloConsolidado = "CONSOLIDATED REPORT"
                    this.tituloConsolidado = this.tituloConsolidado.concat(" ", tituloEN)
                }
            }
            if (this.ReporteConsol && !this.consol) {
                if (this.$store.state._language == "es-ES") {
                    this.tituloConsolidado = titulo.concat(" AJUSTES CONSOLIDADOS")
                } else {
                    this.tituloConsolidado = "CONSOLIDATED ADJUSTMENT"
                    this.tituloConsolidado = this.tituloConsolidado.concat(" ", tituloEN)
                }
            }
            if (this.Notas) {
                if (this.$store.state._language == "es-ES") {
                    this.tituloConsolidado = "NOTAS A LOS ESTADOS FINANCIEROS"
                } else {
                    this.tituloConsolidado = "NOTES TO THE FINANCIAL STATEMENTS"
                }
            }
            this.tituloConsolidado = this.tituloConsolidado.concat(" ", this.vigencia.toUpperCase());
            if (this.moneda) {
                this.tituloConsolidado = this.tituloConsolidado.concat(" ", this.labels.moneda, " ", this.moneda);
            }
        },

        f1_titulo() {
            let v_titulo = ""
            if (this.Notas) {
                v_titulo = "NOTAS A LOS ESTADOS FINANCIEROS"
            } else {
                v_titulo = "CUENTAS CONTABLES"
            }
            let titulo = v_titulo + " " + (this.formCuentas.descripcion || '')
            return titulo
        },

        generar() {
            if (!this.empresasSeleccion || this.EmpresasConsolida.length === 0) {
                if (!this.dialogCompanias) {
                    this.$toast.warning("Por favor seleccione una compañía");
                    return;
                }
            }

            if (!this.dialogFechas) {
                this.$toast.warning("Por favor seleccione una vigencia");
                return;
            }
            if (!this.dialogReportes) {
                this.$toast.warning("Por favor seleccione un reporte");
                return;
            }

            this.isLoading = true;
            this.idCompania = this.dialogCompanias;
            this.vigencia = this.dialogFechas;
            this.codReporte = this.dialogReportes;
            this.isEmpty = true;
            this.generado = false;
            this.consol = true;

            const empresasSeleccionadas = [...this.EmpresasConsolida];
            const hayEmpresasSeleccionadas = this.empresasSeleccion && empresasSeleccionadas.length > 0;

            this.empresasSeleccion = false;
            this.selectAllCompanies = false;

            const checkboxEmpresas = document.getElementById("Empresas");
            if (checkboxEmpresas) {
                checkboxEmpresas.checked = false;
            }
            const checkboxEmpresasReporte = document.getElementById("EmpresasReporte");
            if (checkboxEmpresasReporte) {
                checkboxEmpresasReporte.checked = false;
            }

            this.f_titulo()

            switch (this.$route.name) {
                case "reporteEcp":
                    if (this.Balance) {
                        Balance.getReporteEcp(this.idCompania, this.vigencia, this.codReporte)
                            .then((result) => {
                                this.balance = result.data.reporteEcp;
                                this.searched = this.balance;
                                if (this.balance && this.balance.length != 0) {
                                    this.isEmpty = false;
                                    this.generado = true;
                                }
                                this.isLoading = false;
                            })
                            .catch(() => {
                                this.error = true;
                                this.isLoading = false;
                            });
                    }

                    if (this.Consolidado && !this.Empresas) {
                        let empresasParam = [];
                        if (!hayEmpresasSeleccionadas) {
                            empresasParam = [this.idCompania];
                        } else {
                            empresasParam = empresasSeleccionadas;
                        }

                        Balance.getReporteEcpConsol(empresasParam, this.vigencia, this.codReporte)
                            .then((result) => {
                                this.balance = result.data.reporteEcp;
                                this.searched = this.balance;
                                if (this.balance && this.balance.length != 0) {
                                    this.isEmpty = false;
                                    this.generado = true;
                                    this.columnas = this.balance[0]?.columnas || 0;
                                    this.f_columnas();
                                }
                                this.EmpresasConsolida = [];
                                this.isLoading = false;
                            })
                            .catch(() => {
                                this.error = true;
                                this.isLoading = false;
                            });
                    }

                    if (this.Consolidado && this.Empresas) {
                        if (empresasSeleccionadas.length === 0) {
                            this.$toast.warning("Por favor seleccione empresas para consolidar");
                            this.isLoading = false;
                            return;
                        }

                        Balance.getReporteEcpConsol(empresasSeleccionadas, this.vigencia, this.codReporte)
                            .then((result) => {
                                this.balance = result.data.reporteEcp;
                                this.searched = this.balance;
                                if (this.balance && this.balance.length != 0) {
                                    this.isEmpty = false;
                                    this.generado = true;
                                    this.columnas = this.balance[0]?.columnas || 0;
                                    this.f_columnas();
                                }
                                this.EmpresasConsolida = [];
                                this.isLoading = false;
                            })
                            .catch(() => {
                                this.error = true;
                                this.isLoading = false;
                            });
                    }

                    if (this.Comparativo) {
                        Balance.getReporteEcpCompar(this.idCompania, this.vigencia, this.codReporte)
                            .then((result) => {
                                this.balance = result.data.reporteEcp;
                                this.searched = this.balance;
                                if (this.balance && this.balance.length != 0) {
                                    this.isEmpty = false;
                                    this.generado = true;
                                }
                                this.isLoading = false;
                            })
                            .catch(() => {
                                this.error = true;
                                this.isLoading = false;
                            });
                    }

                    if (this.Reporte) {
                        Balance.getReporteEcpFinal(this.idCompania, this.vigencia, this.codReporte)
                            .then((result) => {
                                this.balance = result.data.reporteEcp;
                                this.searched = this.balance;
                                if (this.balance && this.balance.length != 0) {
                                    this.isEmpty = false;
                                    this.generado = true;
                                    this.f_columnas_ecp();
                                }
                                this.isLoading = false;
                            })
                            .catch(() => {
                                this.error = true;
                                this.isLoading = false;
                            });
                    }

                    if (this.Informacion) {
                        Balance.getReporteEcpInformacion(this.idCompania, this.vigencia, this.codReporte, this.$store.state.userId)
                            .then((result) => {
                                this.balance = result.data.informacionManual;
                                this.searched = this.balance;
                                if (this.balance && this.balance.length != 0) {
                                    this.isEmpty = false;
                                    this.generado = true;
                                }
                                this.isLoading = false;
                            })
                            .catch(() => {
                                this.error = true;
                                this.isLoading = false;
                            });
                    }

                    if (this.ReporteConsol && !this.EmpresasReporte) {
                        let empresasParam = [];
                        if (!hayEmpresasSeleccionadas) {
                            empresasParam = [this.idCompania];
                        } else {
                            empresasParam = empresasSeleccionadas;
                        }

                        Balance.getReporteEcpFinalConsol(empresasParam, this.vigencia, this.codReporte)
                            .then((result) => {
                                this.balance = result.data.reporteEcp;
                                this.ajustes = result.data.ajustesECP;
                                this.searched = this.balance;
                                this.consol = true;
                                if (this.balance && this.balance.length != 0) {
                                    this.isEmpty = false;
                                    this.generado = true;
                                    this.f_columnas_ecp();
                                }
                                this.EmpresasConsolida = [];
                                this.isLoading = false;
                            })
                            .catch(() => {
                                this.error = true;
                                this.isLoading = false;
                            });
                    }

                    if (this.ReporteConsol && this.EmpresasReporte) {
                        if (empresasSeleccionadas.length === 0) {
                            this.$toast.warning("Por favor seleccione empresas para consolidar");
                            this.isLoading = false;
                            return;
                        }

                        Balance.getReporteEcpFinalConsol(empresasSeleccionadas, this.vigencia, this.codReporte)
                            .then((result) => {
                                this.balance = result.data.reporteEcp;
                                this.ajustes = result.data.ajustesECP;
                                this.searched = this.balance;
                                this.consol = true;
                                if (this.balance && this.balance.length != 0) {
                                    this.isEmpty = false;
                                    this.generado = true;
                                    this.f_columnas_ecp();
                                }
                                this.EmpresasConsolida = [];
                                this.isLoading = false;
                            })
                            .catch(() => {
                                this.error = true;
                                this.isLoading = false;
                            });
                    }

                    if (this.Notas) {
                        Balance.getNotasEF(this.idCompania, this.vigencia, "ECP")
                            .then((result) => {
                                this.notasEF = result.data.notasEF;
                                this.searched = this.notasEF;
                                if (this.notasEF && this.notasEF.length != 0) {
                                    this.isEmpty = false;
                                    this.generado = true;
                                }
                                this.isLoading = false;
                            })
                            .catch(() => {
                                this.error = true;
                                this.isLoading = false;
                            });
                    }
                    break;
            }
        },

        cambiaAjuste() {
            if (this.consol) {
                this.consol = false
                this.balance = this.ajustes
            } else {
                this.consol = true
                this.balance = this.searched
            }
            this.f_titulo()
        },

        f_columnas() {
            if (this.balance && this.balance.length > 0) {
                for (let idx = 0; idx < this.columnas; idx++) {
                    switch (idx) {
                        case 0: this.titulo_columna[idx] = this.balance[0].e1; break;
                        case 1: this.titulo_columna[idx] = this.balance[0].e2; break;
                        case 2: this.titulo_columna[idx] = this.balance[0].e3; break;
                        case 3: this.titulo_columna[idx] = this.balance[0].e4; break;
                        case 4: this.titulo_columna[idx] = this.balance[0].e5; break;
                    }
                }
            }
        },

        f_columnas_ecp() {
            if (this.ecpcolumnas && this.ecpcolumnas.length > 0) {
                for (let idx = 0; idx < this.maxcolumnas; idx++) {
                    this.titulo_columna_ecp[idx] = this.ecpcolumnas[idx].descripcion.substring(0, 20)
                }
            }
        },

        titulo(opcion) {
            let periodo_anterior = parseInt(this.vigencia.substring(0, 4)) - 1;
            let v_periodo_anterior = ""
            v_periodo_anterior = v_periodo_anterior.concat(periodo_anterior, this.vigencia.substring(4));
            if (opcion == 0) {
                return this.labels.saldo_actual + " " + v_periodo_anterior;
            }
            if (opcion == 1) {
                return this.labels.saldo_actual + " " + this.vigencia;
            }
            if (opcion == 2) {
                return this.labels.funcional1 + " " + v_periodo_anterior;
            }
            if (opcion == 3) {
                return this.labels.funcional1 + " " + this.vigencia;
            }
        },

        f_escribe_renglon(v_informacion) {
            if (v_informacion === "E") return false;
            return true;
        },

		uncheck(opcion) {
			var checkbox1 = document.getElementById("Balance");
			var checkbox2 = document.getElementById("Consolidado");
			var checkbox21 = document.getElementById("Empresas");
			var checkbox3 = document.getElementById("Comparativo");
			var checkbox4 = document.getElementById("Reporte");
			var checkbox5 = document.getElementById("Informacion");
			var checkbox6 = document.getElementById("ReporteConsol");
			var checkbox61 = document.getElementById("EmpresasReporte");
			var checkbox7 = document.getElementById("Notas");

			if (opcion == 21) {
				if (this.empresasSeleccion) {
					this.empresasSeleccion = false;
					this.EmpresasConsolida = [];
				} else {
					this.empresasSeleccion = true;
				}
				// Actualizar el estado del checkbox Empresas
				this.Empresas = this.empresasSeleccion;
				return;
			}

			if (opcion == 61) {
				if (this.empresasSeleccion) {
					this.empresasSeleccion = false;
					this.EmpresasConsolida = [];
				} else {
					this.empresasSeleccion = true;
				}
				// Actualizar el estado del checkbox EmpresasReporte
				this.EmpresasReporte = this.empresasSeleccion;
				return;
			}

			// El resto del código para desmarcar checkboxes
			checkbox1.checked = false;
			checkbox2.checked = false;
			if (checkbox21) checkbox21.checked = false;
			checkbox3.checked = false;
			checkbox4.checked = false;
			checkbox5.checked = false;
			checkbox6.checked = false;
			if (checkbox61) checkbox61.checked = false;
			checkbox7.checked = false;

			this.Balance = false;
			this.Comparativo = false;
			this.Consolidado = false;
			this.Empresas = false;
			this.EmpresasReporte = false;
			this.Reporte = false;
			this.ReporteConsol = false;
			this.Informacion = false;
			this.Notas = false;
			this.empresasSeleccion = false;

			if (opcion == 1) {
				checkbox1.checked = true;
				this.Balance = true;
			}
			if (opcion == 2) {
				checkbox2.checked = true;
				this.Consolidado = true;
				this.Empresas = false;
			}
			if (opcion == 3) {
				checkbox3.checked = true;
				this.Comparativo = true;
			}
			if (opcion == 4) {
				checkbox4.checked = true;
				this.Reporte = true;
			}
			if (opcion == 5) {
				checkbox5.checked = true;
				this.Informacion = true;
			}
			if (opcion == 6) {
				checkbox6.checked = true;
				this.ReporteConsol = true;
				this.EmpresasReporte = false;
			}
			if (opcion == 7) {
				checkbox7.checked = true;
				this.Notas = true;
			}

			this.isEmpty = true;
			this.generado = false;
		},

        excel(opcion) {
            let datos = {}
            datos.titulo = this.tituloConsolidado
            if (opcion === 1) {
                datos.opcion = 1
                datos.idCompania = this.idCompania
                const v_compania = this.companias.find((compania) => compania.id === this.idCompania)
                datos.compania = v_compania ? v_compania.nombre : ''
                datos.vigencia = this.vigencia
                datos.informacion = this.balanceFiltrado
                datos.userId = this.$store.state.userId
                datos.userName = this.$store.state.userName
                this.hojaExcelBalance(datos)
            }
            if (opcion === 2) {
                datos.opcion = 2
                datos.idCompania = this.idCompania
                const v_compania = this.companias.find((compania) => compania.id === this.idCompania)
                datos.compania = v_compania ? v_compania.nombre : ''
                datos.vigencia = this.vigencia
                datos.informacion = this.balanceFiltrado
                datos.columnas = [
                    this.titulo(0),
                    this.titulo(1),
                    this.labels.diferencia,
                    this.titulo(2),
                    this.titulo(3),
                    this.labels.funcional_dif
                ]
                datos.userId = this.$store.state.userId
                datos.userName = this.$store.state.userName
                this.hojaExcelComparativo(datos)
            }
            if (opcion === 3) {
                datos.opcion = 3
                datos.idCompania = this.idCompania
                const v_compania = this.companias.find((compania) => compania.id === this.idCompania)
                datos.compania = v_compania ? v_compania.nombre : ''
                datos.vigencia = this.vigencia
                datos.informacion = this.balanceFiltrado
                datos.columnasCount = this.columnas
                datos.userId = this.$store.state.userId
                datos.userName = this.$store.state.userName
                this.hojaExcelConsolidado(datos)
            }
            if (opcion === 4) {
                datos.idCompania = this.idCompania
                const v_compania = this.companias.find((compania) => compania.id === this.idCompania)
                datos.compania = v_compania ? v_compania.nombre : ''
                datos.vigencia = this.vigencia
                datos.informacion = this.balanceFiltrado
                datos.userId = this.$store.state.userId
                datos.userName = this.$store.state.userName
                this.hojaExcelReporteEcpInformacion(datos)
            }
            if (opcion === 5) {
                datos.opcion = 5
                datos.idCompania = this.idCompania
                const v_compania = this.companias.find((compania) => compania.id === this.idCompania)
                datos.compania = v_compania ? v_compania.nombre : ''
                datos.vigencia = this.vigencia
                datos.informacion = this.balanceFiltrado
                datos.maxcolumnas = this.maxcolumnas
                datos.userId = this.$store.state.userId
                datos.userName = this.$store.state.userName
                this.hojaExcelReporteEcp(datos)
            }
        },

        async hojaExcelBalance(datos) {
            let createdAt1 = new Date()
            let anio = createdAt1.getFullYear()
            let mes = String(createdAt1.getMonth() + 1).padStart(2, '0')
            let dia = String(createdAt1.getDate()).padStart(2, '0')
            let createdAt = anio + "-" + mes + "-" + dia

            let compania = datos.compania
            let vigencia = datos.vigencia
            let titulo = datos.titulo
            let userName = datos.userName
            const filas = datos.informacion

            if (!filas || filas.length === 0) {
                this.$toast.warning("No hay datos para exportar")
                return
            }

            const { Workbook } = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("BalanceECP")

            const styles = {
                tituloPrincipal: {
                    font: { name: "Calibri", size: 16, bold: true },
                    alignment: { horizontal: "center", vertical: "middle" }
                },
                subtitulo: {
                    font: { name: "Calibri", size: 11, bold: true },
                    alignment: { horizontal: "center", vertical: "middle" }
                },
                encabezado: {
                    font: { name: "Calibri", size: 11, bold: true },
                    alignment: { horizontal: "center", vertical: "middle" },
                    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
                    border: {
                        top: { style: "thin" },
                        left: { style: "thin" },
                        bottom: { style: "thin" },
                        right: { style: "thin" }
                    }
                },
                nivel1: {
                    font: { name: "Calibri", size: 12, bold: true },
                    alignment: { horizontal: "left", vertical: "middle" },
                    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F2F2F2" } },
                    border: {
                        bottom: { style: "thin" }
                    }
                },
                nivel2: {
                    font: { name: "Calibri", size: 11, bold: true },
                    alignment: { horizontal: "left", vertical: "middle" },
                    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F8F8F8" } },
                    indent: 1
                },
                datoNormal: {
                    font: { name: "Calibri", size: 10 },
                    alignment: { horizontal: "right", vertical: "middle" },
                    numFmt: "#,##0",
                    border: {
                        left: { style: "thin" },
                        right: { style: "thin" }
                    },
                    indent: 2
                },
                total: {
                    font: { name: "Calibri", size: 11, bold: true },
                    alignment: { horizontal: "right", vertical: "middle" },
                    numFmt: "#,##0",
                    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
                    border: {
                        top: { style: "medium" },
                        bottom: { style: "double" }
                    }
                },
                descripcionTotal: {
                    font: { name: "Calibri", size: 11, bold: true },
                    alignment: { horizontal: "right", vertical: "middle" },
                    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
                    border: {
                        top: { style: "medium" },
                        bottom: { style: "double" }
                    }
                }
            }

            worksheet.mergeCells('A1:F1')
            worksheet.getCell('A1').value = titulo
            Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal)

            worksheet.mergeCells('A2:F2')
            worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Compañía: ${compania}`
            Object.assign(worksheet.getCell('A2'), styles.subtitulo)

            worksheet.mergeCells('A3:F3')
            worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName}`
            Object.assign(worksheet.getCell('A3'), styles.subtitulo)

            worksheet.addRow([])

            const HEADER_ROW = [
                'DESCRIPCIÓN',
                'SALDO',
                'FUNCIONAL',
                'PROMEDIO',
                'ALTERNA',
                'PROMEDIO',
            ]

            const headerRow = worksheet.addRow(HEADER_ROW)
            headerRow.eachCell((cell) => {
                Object.assign(cell, styles.encabezado)
            })

            let n_fila = 6

            filas.forEach((fila) => {
                if (fila.informacion === "E") {
                    const rowData = [fila.descripcion || '', '', '', '', '', '']
                    worksheet.addRow(rowData)
                    worksheet.mergeCells(`A${n_fila}:F${n_fila}`)
                    Object.assign(worksheet.getCell(`A${n_fila}`), styles.nivel1)

                    for (let col = 1; col <= 6; col++) {
                        const cell = worksheet.getCell(n_fila, col)
                        cell.border = {
                            left: { style: "thin" },
                            right: { style: "thin" },
                            top: { style: "thin" },
                            bottom: { style: "thin" }
                        }
                    }
                    n_fila++

                } else {
                    const saldo = fila.saldo_actual !== null ? parseFloat(fila.saldo_actual) || 0 : 0
                    const funcional1 = fila.funcional1 !== null ? parseFloat(fila.funcional1) || 0 : 0
                    const promedio1 = fila.promedio1 !== null ? parseFloat(fila.promedio1) || 0 : 0
                    const funcional2 = fila.funcional2 !== null ? parseFloat(fila.funcional2) || 0 : 0
                    const promedio2 = fila.promedio2 !== null ? parseFloat(fila.promedio2) || 0 : 0

                    const v_fila = [
                        fila.descripcion || '',
                        saldo,
                        funcional1,
                        promedio1,
                        funcional2,
                        promedio2
                    ]

                    const currentRow = worksheet.addRow(v_fila)

                    if (fila.informacion === "T") {
                        currentRow.eachCell((cell, colNumber) => {
                            if (colNumber === 1) {
                                Object.assign(cell, styles.descripcionTotal)
                            } else {
                                Object.assign(cell, styles.total)
                            }
                        })
                    } else {
                        currentRow.eachCell((cell, colNumber) => {
                            if (colNumber === 1) {
                                cell.font = { name: "Calibri", size: 10 }
                                cell.alignment = { horizontal: "left", vertical: "middle" }
                                cell.indent = 2

                                if (fila.segundo_nivel > 0 && fila.segundo_nivel < 999) {
                                    cell.font.bold = true
                                }
                            } else {
                                Object.assign(cell, styles.datoNormal)
                            }

                            cell.border = {
                                left: { style: "thin" },
                                right: { style: "thin" },
                                top: { style: "thin" },
                                bottom: { style: "thin" }
                            }
                        })
                    }
                    n_fila++
                }
            })

            worksheet.columns = [
                { width: 60 },
                { width: 18 },
                { width: 18 },
                { width: 18 },
                { width: 18 },
                { width: 18 }
            ]

            worksheet.views = [
                { state: 'frozen', ySplit: 5 }
            ]

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = `BalanceECP_${vigencia}_${createdAt}.xlsx`
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            )

            downloadLink.style.display = "none"
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
            window.URL.revokeObjectURL(downloadLink.href)
        },

        async hojaExcelComparativo(datos) {
            let createdAt1 = new Date()
            let anio = createdAt1.getFullYear()
            let mes = String(createdAt1.getMonth() + 1).padStart(2, '0')
            let dia = String(createdAt1.getDate()).padStart(2, '0')
            let createdAt = anio + "-" + mes + "-" + dia

            let compania = datos.compania
            let vigencia = datos.vigencia
            let titulo = datos.titulo
            let columnas = datos.columnas
            let userName = datos.userName
            const filas = datos.informacion

            if (!filas || filas.length === 0) {
                this.$toast.warning("No hay datos para exportar")
                return
            }

            const { Workbook } = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("ComparativoECP")

            const styles = {
                tituloPrincipal: {
                    font: { name: "Calibri", size: 16, bold: true },
                    alignment: { horizontal: "center", vertical: "middle" }
                },
                subtitulo: {
                    font: { name: "Calibri", size: 11, bold: true },
                    alignment: { horizontal: "center", vertical: "middle" }
                },
                encabezado: {
                    font: { name: "Calibri", size: 11, bold: true },
                    alignment: { horizontal: "center", vertical: "middle" },
                    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
                    border: {
                        top: { style: "thin" },
                        left: { style: "thin" },
                        bottom: { style: "thin" },
                        right: { style: "thin" }
                    }
                },
                nivel1: {
                    font: { name: "Calibri", size: 12, bold: true },
                    alignment: { horizontal: "left", vertical: "middle" },
                    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F2F2F2" } },
                    border: {
                        bottom: { style: "thin" }
                    }
                },
                nivel2: {
                    font: { name: "Calibri", size: 11, bold: true },
                    alignment: { horizontal: "left", vertical: "middle" },
                    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F8F8F8" } },
                    indent: 1
                },
                datoNormal: {
                    font: { name: "Calibri", size: 10 },
                    alignment: { horizontal: "right", vertical: "middle" },
                    numFmt: "#,##0",
                    border: {
                        left: { style: "thin" },
                        right: { style: "thin" }
                    },
                    indent: 2
                },
                total: {
                    font: { name: "Calibri", size: 11, bold: true },
                    alignment: { horizontal: "right", vertical: "middle" },
                    numFmt: "#,##0",
                    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
                    border: {
                        top: { style: "medium" },
                        bottom: { style: "double" }
                    }
                },
                descripcionTotal: {
                    font: { name: "Calibri", size: 11, bold: true },
                    alignment: { horizontal: "right", vertical: "middle" },
                    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
                    border: {
                        top: { style: "medium" },
                        bottom: { style: "double" }
                    }
                }
            }

            worksheet.mergeCells('A1:G1')
            worksheet.getCell('A1').value = titulo
            Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal)

            worksheet.mergeCells('A2:G2')
            worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Compañía: ${compania}`
            Object.assign(worksheet.getCell('A2'), styles.subtitulo)

            worksheet.mergeCells('A3:G3')
            worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName}`
            Object.assign(worksheet.getCell('A3'), styles.subtitulo)

            worksheet.addRow([])

            const HEADER_ROW = [
                'DESCRIPCIÓN',
                columnas[0],
                columnas[1],
                columnas[2],
                columnas[3],
                columnas[4],
                columnas[5],
            ]

            const headerRow = worksheet.addRow(HEADER_ROW)
            headerRow.eachCell((cell) => {
                Object.assign(cell, styles.encabezado)
            })

            let n_fila = 6

            filas.forEach((fila) => {
                if (fila.informacion === "E") {
                    const rowData = [fila.descripcion || '', '', '', '', '', '', '']
                    worksheet.addRow(rowData)
                    worksheet.mergeCells(`A${n_fila}:G${n_fila}`)
                    Object.assign(worksheet.getCell(`A${n_fila}`), styles.nivel1)

                    for (let col = 1; col <= 7; col++) {
                        const cell = worksheet.getCell(n_fila, col)
                        cell.border = {
                            left: { style: "thin" },
                            right: { style: "thin" },
                            top: { style: "thin" },
                            bottom: { style: "thin" }
                        }
                    }
                    n_fila++

                } else {
                    const anterior = fila.anterior !== null ? parseFloat(fila.anterior) || 0 : 0
                    const actual = fila.actual !== null ? parseFloat(fila.actual) || 0 : 0
                    const diferencia = fila.diferencia !== null ? parseFloat(fila.diferencia) || 0 : 0
                    const funcional_ant = fila.funcional_ant !== null ? parseFloat(fila.funcional_ant) || 0 : 0
                    const funcional_act = fila.funcional_act !== null ? parseFloat(fila.funcional_act) || 0 : 0
                    const funcional_dif = fila.funcional_dif !== null ? parseFloat(fila.funcional_dif) || 0 : 0

                    const v_fila = [
                        fila.descripcion || '',
                        anterior,
                        actual,
                        diferencia,
                        funcional_ant,
                        funcional_act,
                        funcional_dif
                    ]

                    const currentRow = worksheet.addRow(v_fila)

                    if (fila.informacion === "T") {
                        currentRow.eachCell((cell, colNumber) => {
                            if (colNumber === 1) {
                                Object.assign(cell, styles.descripcionTotal)
                            } else {
                                Object.assign(cell, styles.total)
                            }
                        })
                    } else {
                        currentRow.eachCell((cell, colNumber) => {
                            if (colNumber === 1) {
                                cell.font = { name: "Calibri", size: 10 }
                                cell.alignment = { horizontal: "left", vertical: "middle" }
                                cell.indent = 2

                                if (fila.segundo_nivel > 0 && fila.segundo_nivel < 999) {
                                    cell.font.bold = true
                                }
                            } else {
                                Object.assign(cell, styles.datoNormal)
                            }

                            cell.border = {
                                left: { style: "thin" },
                                right: { style: "thin" },
                                top: { style: "thin" },
                                bottom: { style: "thin" }
                            }
                        })
                    }
                    n_fila++
                }
            })

            worksheet.columns = [
                { width: 60 },
                { width: 18 },
                { width: 18 },
                { width: 18 },
                { width: 18 },
                { width: 18 },
                { width: 18 }
            ]

            worksheet.views = [
                { state: 'frozen', ySplit: 5 }
            ]

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = `ComparativoECP_${vigencia}_${createdAt}.xlsx`
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            )

            downloadLink.style.display = "none"
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
            window.URL.revokeObjectURL(downloadLink.href)
        },

        async hojaExcelConsolidado(datos) {
            let createdAt1 = new Date()
            let anio = createdAt1.getFullYear()
            let mes = String(createdAt1.getMonth() + 1).padStart(2, '0')
            let dia = String(createdAt1.getDate()).padStart(2, '0')
            let createdAt = anio + "-" + mes + "-" + dia

            let compania = datos.compania
            let vigencia = datos.vigencia
            let titulo = datos.titulo
            let columnasCount = datos.columnasCount
            let userName = datos.userName
            const filas = datos.informacion

            if (!filas || filas.length === 0) {
                this.$toast.warning("No hay datos para exportar")
                return
            }

            const { Workbook } = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("ConsolidadoECP")

            const styles = {
                tituloPrincipal: {
                    font: { name: "Calibri", size: 16, bold: true },
                    alignment: { horizontal: "center", vertical: "middle" }
                },
                subtitulo: {
                    font: { name: "Calibri", size: 11, bold: true },
                    alignment: { horizontal: "center", vertical: "middle" }
                },
                encabezado: {
                    font: { name: "Calibri", size: 11, bold: true },
                    alignment: { horizontal: "center", vertical: "middle" },
                    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
                    border: {
                        top: { style: "thin" },
                        left: { style: "thin" },
                        bottom: { style: "thin" },
                        right: { style: "thin" }
                    }
                },
                nivel1: {
                    font: { name: "Calibri", size: 12, bold: true },
                    alignment: { horizontal: "left", vertical: "middle" },
                    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F2F2F2" } },
                    border: {
                        bottom: { style: "thin" }
                    }
                },
                nivel2: {
                    font: { name: "Calibri", size: 11, bold: true },
                    alignment: { horizontal: "left", vertical: "middle" },
                    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F8F8F8" } },
                    indent: 1
                },
                datoNormal: {
                    font: { name: "Calibri", size: 10 },
                    alignment: { horizontal: "right", vertical: "middle" },
                    numFmt: "#,##0",
                    border: {
                        left: { style: "thin" },
                        right: { style: "thin" }
                    },
                    indent: 2
                },
                total: {
                    font: { name: "Calibri", size: 11, bold: true },
                    alignment: { horizontal: "right", vertical: "middle" },
                    numFmt: "#,##0",
                    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
                    border: {
                        top: { style: "medium" },
                        bottom: { style: "double" }
                    }
                },
                descripcionTotal: {
                    font: { name: "Calibri", size: 11, bold: true },
                    alignment: { horizontal: "right", vertical: "middle" },
                    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
                    border: {
                        top: { style: "medium" },
                        bottom: { style: "double" }
                    }
                }
            }

            const totalColumns = 3 + columnasCount
            const endCol = String.fromCharCode(65 + totalColumns - 1)

            worksheet.mergeCells(`A1:${endCol}1`)
            worksheet.getCell('A1').value = titulo
            Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal)

            worksheet.mergeCells(`A2:${endCol}2`)
            worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Compañía: ${compania}`
            Object.assign(worksheet.getCell('A2'), styles.subtitulo)

            worksheet.mergeCells(`A3:${endCol}3`)
            worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName}`
            Object.assign(worksheet.getCell('A3'), styles.subtitulo)

            worksheet.addRow([])

            const headerRowArray = ['DESCRIPCIÓN']
            for (let i = 0; i < columnasCount; i++) {
                headerRowArray.push(this.titulo_columna[i] || `Empresa ${i + 1}`)
            }
            headerRowArray.push('AJUSTES')
            headerRowArray.push('CONSOLIDADO')

            const headerRow = worksheet.addRow(headerRowArray)
            headerRow.eachCell((cell) => {
                Object.assign(cell, styles.encabezado)
            })

            let n_fila = 6

            filas.forEach((fila) => {
                if (fila.informacion === "E") {
                    const rowData = [fila.descripcion || '']
                    for (let i = 0; i < columnasCount + 2; i++) {
                        rowData.push('')
                    }
                    worksheet.addRow(rowData)
                    worksheet.mergeCells(`A${n_fila}:${endCol}${n_fila}`)
                    Object.assign(worksheet.getCell(`A${n_fila}`), styles.nivel1)

                    for (let col = 1; col <= totalColumns; col++) {
                        const cell = worksheet.getCell(n_fila, col)
                        cell.border = {
                            left: { style: "thin" },
                            right: { style: "thin" },
                            top: { style: "thin" },
                            bottom: { style: "thin" }
                        }
                    }
                    n_fila++

                } else if (this.f_escribe_renglon(fila.informacion)) {
                    const rowData = [fila.descripcion || '']

                    for (let i = 1; i <= columnasCount; i++) {
                        const valor = fila[`c${i}`] !== null ? parseFloat(fila[`c${i}`]) || 0 : 0
                        rowData.push(valor)
                    }

                    const ajustes = fila.ajustes !== null ? parseFloat(fila.ajustes) || 0 : 0
                    const total = fila.total !== null ? parseFloat(fila.total) || 0 : 0
                    rowData.push(ajustes)
                    rowData.push(total)

                    const currentRow = worksheet.addRow(rowData)

                    if (fila.informacion === "T" || (fila.informacion === "S" && fila.segundo_nivel === 999)) {
                        currentRow.eachCell((cell, colNumber) => {
                            if (colNumber === 1) {
                                Object.assign(cell, styles.descripcionTotal)
                            } else {
                                Object.assign(cell, styles.total)
                            }
                        })
                    } else {
                        currentRow.eachCell((cell, colNumber) => {
                            if (colNumber === 1) {
                                if (fila.segundo_nivel > 0 && fila.segundo_nivel < 999) {
                                    Object.assign(cell, styles.nivel2)
                                } else {
                                    cell.font = { name: "Calibri", size: 10 }
                                    cell.alignment = { horizontal: "left", vertical: "middle" }
                                    cell.indent = 2
                                }
                            } else {
                                Object.assign(cell, styles.datoNormal)
                            }

                            cell.border = {
                                left: { style: "thin" },
                                right: { style: "thin" },
                                top: { style: "thin" },
                                bottom: { style: "thin" }
                            }
                        })
                    }
                    n_fila++
                }
            })

            const columnWidths = [{ width: 50 }]
            for (let i = 0; i < columnasCount; i++) {
                columnWidths.push({ width: 18 })
            }
            columnWidths.push({ width: 18 })
            columnWidths.push({ width: 18 })
            worksheet.columns = columnWidths

            worksheet.views = [
                { state: 'frozen', ySplit: 5 }
            ]

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = `ConsolidadoECP_${vigencia}_${createdAt}.xlsx`
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            )

            downloadLink.style.display = "none"
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
            window.URL.revokeObjectURL(downloadLink.href)
        },

        async hojaExcelReporteEcpInformacion(datos) {
            let createdAt1 = new Date()
            let anio = createdAt1.getFullYear()
            let mes = String(createdAt1.getMonth() + 1).padStart(2, '0')
            let dia = String(createdAt1.getDate()).padStart(2, '0')
            let createdAt = anio + "-" + mes + "-" + dia

            let compania = datos.compania
            let vigencia = datos.vigencia
            let titulo = datos.titulo
            let userName = datos.userName
            const filas = datos.informacion

            if (!filas || filas.length === 0) {
                this.$toast.warning("No hay datos para exportar")
                return
            }

            const { Workbook } = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("ECPInformacion")

            const styles = {
                tituloPrincipal: {
                    font: { name: "Calibri", size: 16, bold: true },
                    alignment: { horizontal: "center", vertical: "middle" }
                },
                subtitulo: {
                    font: { name: "Calibri", size: 11, bold: true },
                    alignment: { horizontal: "center", vertical: "middle" }
                },
                encabezado: {
                    font: { name: "Calibri", size: 11, bold: true },
                    alignment: { horizontal: "center", vertical: "middle" },
                    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
                    border: {
                        top: { style: "thin" },
                        left: { style: "thin" },
                        bottom: { style: "thin" },
                        right: { style: "thin" }
                    }
                },
                datoNormal: {
                    font: { name: "Calibri", size: 10 },
                    alignment: { horizontal: "left", vertical: "middle" },
                    border: {
                        left: { style: "thin" },
                        right: { style: "thin" },
                        top: { style: "thin" },
                        bottom: { style: "thin" }
                    }
                },
                numero: {
                    font: { name: "Calibri", size: 10 },
                    alignment: { horizontal: "right", vertical: "middle" },
                    numFmt: "#,##0",
                    border: {
                        left: { style: "thin" },
                        right: { style: "thin" },
                        top: { style: "thin" },
                        bottom: { style: "thin" }
                    }
                }
            }

            worksheet.mergeCells('A1:C1')
            worksheet.getCell('A1').value = titulo
            Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal)

            worksheet.mergeCells('A2:C2')
            worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Compañía: ${compania}`
            Object.assign(worksheet.getCell('A2'), styles.subtitulo)

            worksheet.mergeCells('A3:C3')
            worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName}`
            Object.assign(worksheet.getCell('A3'), styles.subtitulo)

            worksheet.addRow([])

            const HEADER_ROW = [
                'FILA',
                'COLUMNA',
                'VALOR'
            ]

            const headerRow = worksheet.addRow(HEADER_ROW)
            headerRow.eachCell((cell) => {
                Object.assign(cell, styles.encabezado)
            })

            filas.forEach((fila) => {
                const valor = fila.valor !== null ? parseFloat(fila.valor) || 0 : 0
                const v_fila = [
                    fila.fila_desc || '',
                    fila.columna_desc || '',
                    valor
                ]

                const currentRow = worksheet.addRow(v_fila)

                currentRow.eachCell((cell, colNumber) => {
                    if (colNumber < 3) {
                        Object.assign(cell, styles.datoNormal)
                    } else {
                        Object.assign(cell, styles.numero)
                    }
                })
            })

            worksheet.columns = [
                { width: 40 },
                { width: 40 },
                { width: 20 }
            ]

            worksheet.views = [
                { state: 'frozen', ySplit: 5 }
            ]

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = `ECPInformacion_${vigencia}_${createdAt}.xlsx`
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            )

            downloadLink.style.display = "none"
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
            window.URL.revokeObjectURL(downloadLink.href)
        },

        async hojaExcelReporteEcp(datos) {
            let createdAt1 = new Date()
            let anio = createdAt1.getFullYear()
            let mes = String(createdAt1.getMonth() + 1).padStart(2, '0')
            let dia = String(createdAt1.getDate()).padStart(2, '0')
            let createdAt = anio + "-" + mes + "-" + dia

            let compania = datos.compania
            let vigencia = datos.vigencia
            let titulo = datos.titulo
            const filas = datos.informacion
            let userName = datos.userName
            let maxcolumnas = datos.maxcolumnas

            if (!filas || filas.length === 0) {
                this.$toast.warning("No hay datos para exportar")
                return
            }

            const { Workbook } = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("ECPReporte")

            const styles = {
                tituloPrincipal: {
                    font: { name: "Calibri", size: 16, bold: true },
                    alignment: { horizontal: "center", vertical: "middle" }
                },
                subtitulo: {
                    font: { name: "Calibri", size: 11, bold: true },
                    alignment: { horizontal: "center", vertical: "middle" }
                },
                encabezado: {
                    font: { name: "Calibri", size: 11, bold: true },
                    alignment: { horizontal: "center", vertical: "middle" },
                    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
                    border: {
                        top: { style: "thin" },
                        left: { style: "thin" },
                        bottom: { style: "thin" },
                        right: { style: "thin" }
                    }
                },
                descripcion: {
                    font: { name: "Calibri", size: 11, bold: true },
                    alignment: { horizontal: "left", vertical: "middle" },
                    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F2F2F2" } },
                    border: {
                        left: { style: "thin" },
                        right: { style: "thin" },
                        top: { style: "thin" },
                        bottom: { style: "thin" }
                    }
                },
                numero: {
                    font: { name: "Calibri", size: 10 },
                    alignment: { horizontal: "right", vertical: "middle" },
                    numFmt: "#,##0",
                    border: {
                        left: { style: "thin" },
                        right: { style: "thin" },
                        top: { style: "thin" },
                        bottom: { style: "thin" }
                    }
                }
            }

            const totalColumns = maxcolumnas + 1
            const endCol = String.fromCharCode(65 + totalColumns - 1)

            worksheet.mergeCells(`A1:${endCol}1`)
            worksheet.getCell('A1').value = titulo
            Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal)

            worksheet.mergeCells(`A2:${endCol}2`)
            worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Compañía: ${compania}`
            Object.assign(worksheet.getCell('A2'), styles.subtitulo)

            worksheet.mergeCells(`A3:${endCol}3`)
            worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName}`
            Object.assign(worksheet.getCell('A3'), styles.subtitulo)

            worksheet.addRow([])

            const headerRowArray = ['FILA / COLUMNA']
            for (let i = 0; i < maxcolumnas; i++) {
                headerRowArray.push(this.titulo_columna_ecp[i] || `Columna ${i + 1}`)
            }

            const headerRow = worksheet.addRow(headerRowArray)
            headerRow.eachCell((cell) => {
                Object.assign(cell, styles.encabezado)
            })

            filas.forEach((fila) => {
                const rowData = [this.f_fila(fila.fila) || '']

                for (let i = 1; i <= maxcolumnas; i++) {
                    const valor = fila[`val${i}`] !== null ? parseFloat(fila[`val${i}`]) || 0 : 0
                    rowData.push(valor)
                }

                const currentRow = worksheet.addRow(rowData)

                currentRow.eachCell((cell, colNumber) => {
                    if (colNumber === 1) {
                        Object.assign(cell, styles.descripcion)
                    } else {
                        Object.assign(cell, styles.numero)
                    }
                })
            })

            const columnWidths = [{ width: 50 }]
            for (let i = 0; i < maxcolumnas; i++) {
                columnWidths.push({ width: 18 })
            }
            worksheet.columns = columnWidths

            worksheet.views = [
                { state: 'frozen', ySplit: 5 }
            ]

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = `ReporteECP_${vigencia}_${createdAt}.xlsx`
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            )

            downloadLink.style.display = "none"
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
            window.URL.revokeObjectURL(downloadLink.href)
        },

        formato(numero) {
            if (numero === null || numero === undefined) return '';
            if (typeof numero === 'string') {
                numero = parseFloat(numero) || 0;
            }
            return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(numero);
        },

        descargar() {
            const link = document.createElement('a');
            link.href = this.rutaExcel
            link.target = '_blank'
            link.download = this.rutaExcel
            document.body.appendChild(link)
            link.click();
            document.body.removeChild(link);
        },

        f_fila(p_fila) {
            if (!this.ecpfilas || this.ecpfilas.length === 0) return ''
            let fila = this.ecpfilas.filter(fila => fila.fila == p_fila)
            return fila.length > 0 ? fila[0].descripcion : ''
        },

        f_columna(p_columna) {
            if (!this.ecpcolumnas || this.ecpcolumnas.length === 0) return ''
            let columna = this.ecpcolumnas.filter(columna => columna.columna == p_columna)
            return columna.length > 0 ? columna[0].descripcion : ''
        },

        f_muestra(r_informacion) {
            this.showDialogInformacion = true
            this.formInformacion = { ...r_informacion }
        },

        f_muestra_nota(r_nota) {
            this.formCuentas = r_nota
            Balance.getNotasDetalle(this.idCompania, this.vigencia, r_nota.numero)
                .then((result) => {
                    this.cuentas = result.data.cuentas
                    this.showDialog = true
                })
                .catch(() => {
                    this.error = true
                });
            setTimeout(() => {
                let t_saldo = 0;
                let t_funcional = 0;
                let t_promedio = 0;
                let t_alterna = 0;
                let t_prom_alterna = 0;
                this.cuentas.forEach((cuenta) => {
                    t_saldo = t_saldo + parseFloat(cuenta.saldo_actual || 0)
                    t_funcional = t_funcional + parseFloat(cuenta.funcional1 || 0)
                    t_promedio = t_promedio + parseFloat(cuenta.promedio1 || 0)
                    t_alterna = t_alterna + parseFloat(cuenta.funcional2 || 0)
                    t_prom_alterna = t_prom_alterna + parseFloat(cuenta.promedio2 || 0)
                })
                let r_cuenta = {}
                r_cuenta.cuenta = ''
                r_cuenta.descripcion = 'TOTAL CONSULTA'
                r_cuenta.saldo_actual = t_saldo
                r_cuenta.funcional1 = t_funcional
                r_cuenta.promedio1 = t_promedio
                r_cuenta.funcional2 = t_alterna
                r_cuenta.promedio2 = t_prom_alterna
                this.cuentas.push(r_cuenta)
            }, 1000)
        },

        f_grabaInformacion() {
            this.formInformacion.u_modifica = this.$store.state.userId
            this.showDialogInformacion = false

            Balance.grabaEcpInformacion(this.idCompania, this.vigencia, this.codReporte, this.formInformacion)
                .then((result) => {
                    if (result.status == 200) {
                        this.$toast.success("Información Grabada")
                    } else {
                        this.$toast.error("Problema al grabar")
                    }
                })
                .catch(() => {
                    this.error = true;
                });
        }
    },

    mounted() {
        this.isLoading = true;

        Balance.leaCompaniaUsuario()
            .then((result) => {
                this.companiaUsuario = result.data.companiaUsuario;
            });

        Balance.getCompanias(true)
            .then((result) => {
                this.companias = result.data.companias;
                this.companiasFiltradas = [...this.companias];
                this.dialogCompanias = '';
                this.codigoCompanias = "{";
                let primero = true;
                let v_companias = [];

                result.data.companias.forEach((element) => {
                    const v_usuario = this.companiaUsuario.find((r_usuario) =>
                        r_usuario.id_usuario == this.$store.state.userId &&
                        r_usuario.id_compania == element.id);
                    if (this.$store.state.userRole == 1 || v_usuario) {
                        v_companias.push(element);
                    }
                });

                this.companias = v_companias;
                this.companiasFiltradas = [...this.companias];

                result.data.companias.forEach(element => {
                    if (!primero) {
                        this.codigoCompanias = this.codigoCompanias + ",";
                    }
                    primero = false;
                    this.codigoCompanias = this.codigoCompanias + "\"id" + element.id + "\":" +
                        "\"" + element.codigo + "\"";
                });

                this.codigoCompanias = this.codigoCompanias + "}";
                this.codigoCompanias = JSON.parse(this.codigoCompanias);
            })
            .catch(() => {
                this.error = true;
            });

        Balance.getFechas()
            .then((result) => {
                this.fechas = result.data.fechas;
                this.dialogFechas = '';
            })
            .catch(() => {
                this.error = true;
            });

        Balance.getReportes()
            .then((result) => {
                this.reportes = result.data.reportes.filter((reporte) => reporte.principal == 1);
            })
            .catch(() => {
                this.error = true;
            });

        Grupo.getAllGrupos()
            .then((result) => {
                this.listGrupos = result.data.grupos;
                this.grupoId = 'todos';
            })
            .catch(() => {
                this.error = true;
            });

        Balance.getEcpFilas()
            .then((result) => {
                this.ecpfilas = result.data.filas;
            })
            .catch(() => {
                this.error = true;
            });

        Balance.getEcpColumnas()
            .then((result) => {
                this.ecpcolumnas = result.data.columnas;
                this.maxcolumnas = this.ecpcolumnas.length;
            })
            .catch(() => {
                this.error = true;
            });

        this.isLoading = false;
        this.f_titulo()
    },
};
</script>

<style scoped>
.balance-table {
    font-size: 14px;
}

.balance-table>>>.md-table-head {
    padding: 8px 4px !important;
}

.balance-table>>>.md-table-cell {
    padding: 8px 4px !important;
    min-width: auto !important;
}

.principal-table>>>.md-table-cell:nth-child(1) {
    width: 400px !important;
    max-width: 400px !important;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: unset !important;
    word-wrap: break-word !important;
    line-height: 1.2 !important;
    height: auto !important;
    min-height: 40px !important;
}

.principal-table>>>.md-table-cell:nth-child(2),
.principal-table>>>.md-table-cell:nth-child(3),
.principal-table>>>.md-table-cell:nth-child(4),
.principal-table>>>.md-table-cell:nth-child(5),
.principal-table>>>.md-table-cell:nth-child(6),
.principal-table>>>.md-table-cell:nth-child(7) {
    width: 150px !important;
    max-width: 150px !important;
}

.detalle-table>>>.md-table-cell:nth-child(1),
.detalle-table>>>.md-table-cell:nth-child(2) {
    width: 300px !important;
    max-width: 300px !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    line-height: 1.2 !important;
}

.detalle-table>>>.md-table-cell:nth-child(3) {
    width: 150px !important;
    max-width: 150px !important;
}

.balance-table>>>.md-table {
    width: 100% !important;
    table-layout: fixed !important;
}

.balance-table>>>.md-table-toolbar {
    min-height: 60px !important;
    padding: 8px 16px !important;
}

.px-2 {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
}

.px-3 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
}

.mr-1 {
    margin-right: 0.25rem !important;
}

.form-control {
    font-size: 0.9rem;
    padding: 0.25rem 0.5rem;
    height: auto;
}

.w-auto {
    width: auto !important;
}

.loading-spinner {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.fs-5 {
    font-size: 1.25rem !important;
}

.fs-4 {
    font-size: 1.5rem !important;
}

.mb-3 {
    margin-bottom: 1rem !important;
}

.form-control-lg {
    font-size: 1.25rem;
    padding: 0.5rem 1rem;
    height: auto;
    line-height: 1.5;
    border-radius: 0.3rem;
}

.btn-lg {
    padding: 0.5rem 1rem;
    font-size: 1.25rem;
    line-height: 1.5;
    border-radius: 0.3rem;
}

.px-5 {
    padding-left: 3rem !important;
    padding-right: 3rem !important;
}

.mx-2 {
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
}

.consolidation-section {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    max-width: 600px;
    margin: 0 auto;
}

.companies-checkbox-list {
    max-height: 300px;
    overflow-y: auto;
    border: 1px solid #ccc;
    padding: 15px;
    border-radius: 5px;
    background-color: white;
}

.checkbox-group .custom-checkbox {
    margin-bottom: 8px;
}

.company-checkbox {
    font-size: 0.95rem;
    padding: 4px 0;
}
</style>

<style src="../main.css"></style>